module.exports = __webpack_public_path__ + "img/Management.6b86ba86.svg";